import { cloneElement, forwardRef, isValidElement, useImperativeHandle, useState } from 'react';
import { Box, Modal } from '@mui/material';

const ModalLayout = ({ children, sx, contentProps, ...props }, ref) => {
  const [open, setOpen] = useState(null);
  const [useProps, setUseProps] = useState({});
  const [disableBackDropClose, setDisableBackdropClose] = useState(props.disableBackDrop);
  // const state=useSelector(state=>state)

  useImperativeHandle(ref, (...rest) => ({
    show: (show, prop, { disableBackDrop } = {}) => {
      console.log({ show, prop, disableBackDrop });

      setOpen(show);
      setDisableBackdropClose(disableBackDrop);
      setUseProps(prop);
      console.log({ rest });
    },
    hide() {
      setOpen(null);
    },
  }));

  const closeHandler = (e, reason) => {
    if (!disableBackDropClose) {
      setOpen(null);
    } else if (reason !== 'backdropClick') {
      setOpen(null);
    }
  };
  console.log({ children, useProps });

  const appendedChildren = () => {
    if (isValidElement(children)) {
      return cloneElement(children, {
        // Append new prop
        onClose: closeHandler,
        ...(useProps && useProps),
        disableBackDropClose,
        setDisableBackdropClose,
      });
    }
    return <Box {...contentProps}>{children || ' '}</Box>;
  };
  return (
    <Modal
      open={!!open}
      onClose={closeHandler}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
      {...props}
    >
      {children ? appendedChildren() : <> </>}
    </Modal>
  );
};

export default forwardRef(ModalLayout);
